var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { styled } from '@mui/material';
import { ChevronDown16, ChevronUp16 } from '@yunex/yds-icons';
import React, { forwardRef } from 'react';
import Button from '../../Button';
import TextField from '../../TextField';
var StepButton = styled(Button)({
    maxHeight: 22,
    minWidth: 30,
    '& svg': { height: 12, width: 12 },
});
var StepInputWrapper = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.palette.text.secondary,
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    });
});
var StepInput = forwardRef(function (_a, ref) {
    var onStepUp = _a.onStepUp, onStepDown = _a.onStepDown, className = _a.className, inputProps = _a.inputProps, props = __rest(_a, ["onStepUp", "onStepDown", "className", "inputProps"]);
    return (React.createElement(StepInputWrapper, __assign({}, { className: className }),
        React.createElement(StepButton, { color: "inherit", fullWidth: true, onClick: onStepUp, tabIndex: -1 },
            React.createElement(ChevronUp16, null)),
        React.createElement(TextField, __assign({ inputProps: __assign({ style: { textAlign: 'center' }, maxLength: 3 }, inputProps), inputRef: ref, onPaste: function (event) {
                event.preventDefault();
            } }, props)),
        React.createElement(StepButton, { color: "inherit", fullWidth: true, onClick: onStepDown, tabIndex: -1 },
            React.createElement(ChevronDown16, null))));
});
StepInput.displayName = 'StepInput';
export default StepInput;
